import React from "react";
import MobileTopBar from "../../2/Controls/MobileTopBar";
import Icon from "../../2/Controls/Icon";
import { isMobileApp } from "../../../actions/Util";

// Page shell: the phone app bar, or the white card beside the web menu rail
const TemplatePage = ({ title, subtitle, showBack, onBack, children, ...props }) => {
  if (isMobileApp()) {
    return (
      <div className="pt-screen">
        <MobileTopBar {...props} title={title} showBack={showBack} onBack={onBack} />
        {children}
      </div>
    );
  }

  return (
    <div className="header-margin">
      <div className="pt-screen pt-screen--web">
        <div className="pt-web-header">
          {showBack && (
            <button type="button" className="pt-web-back" aria-label="Back" onClick={onBack}>
              <Icon type="leftarrow" />
            </button>
          )}
          <div className="pt-web-heading">
            <div className="pt-web-title">{title}</div>
            {subtitle && <div className="pt-web-subtitle">{subtitle}</div>}
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default TemplatePage;
